import ActionTypes from "../constants/ActionTypes";
import axiosInstance from "../helpers/refreshTokenMiddleware";
import BASE_URL from '../constants/Api';

export const fetchWhatNewRequest = () => ({
    type: ActionTypes.FETCH_WHAT_NEW_REQUEST,
});

export const fetchWhatNewSuccess = (data) => ({
    type: ActionTypes.FETCH_WHAT_NEW_SUCCESS,
    payload: { data},
});

export const fetchWhatNewFailure = (error) => ({
    type: ActionTypes.FETCH_WHAT_NEW_FAILURE,
    payload: error,
});


export const fetchWhatNewData = () => async (dispatch) => {
    dispatch(fetchWhatNewRequest());

    try {
        const accessToken = localStorage.getItem('accessToken');

        if (!accessToken) {
        window.location.href = '/login';
        return;
        }

        const response = await axiosInstance.post(BASE_URL + '/top/what-new',
        {}, 
        {
            headers: {
            'Authorization': `Bearer ${accessToken}`
            }
        }
        );

        const whatNew = response.data.respons.data || [];

        dispatch(fetchWhatNewSuccess(whatNew, whatNew.length));

    } catch (error) {
        dispatch(fetchWhatNewFailure(error.message));
    }
};